import React, { useEffect, useState } from "react";
import Layout from "../../layout/Layout";
import AdminGrid from "../../components/adminGrid/adminGrid";
import actionBtn from "../../assets/images/actionbtn.png";
import { Button, Popover, Spin } from "antd"; // Import Spin for loading spinner
import { ImWarning } from "react-icons/im";
import { ImBlocked } from "react-icons/im";
import ReviewsModal from "../../components/reviewsModal/reviewsModal";
import WarningModal from "../../components/warningModal/warningModal";
import styles from "./style.module.css";
import deleteIcon from "../../assets/images/delete-icon.png";
import {
  ADMIN,
  getAllAreas,
  getAllCities,
  getAllCountires,
  getAllProvinces,
  getStudents,
} from "../../services/auth";
import { getStudentDetails } from "../../services/auth";
import { toggleBlockStudent } from "../../services/auth";
import { baseUrl } from "../../services/api";
import toast from "react-hot-toast";
import userIcon from "../../assets/images/user-icon-removebg.png";
import BlockedModal from "../../components/blockedModal/blockedModal";
import { AiOutlineSearch } from "react-icons/ai";
import { id } from "date-fns/locale";
import { StudentDetails } from "./studentDetails";
import { useAllStudents } from "../../queries";
import { Chip } from "@mui/material";

function TotalStudent() {
  const [isReviewsModalVisible, setIsReviewsModalVisible] = useState(false);
  const [isWarningModalVisible, setIsWarningModalVisible] = useState(false);
  const [isBlockedModalVisible, setIsBlockedModalVisible] = useState(false);
  const [data, setData] = useState("");
  const [rowData, setRowData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [input, setInput] = useState("");
  const [blockedMessage, setBlockedMessage] = useState("");
  const [isStudentDetailsVisible, setIsStudentDetailsVisible] = useState(false);
  const [studentDetail, setStudentDetail] = useState();

  const warningModal = (data) => {
    setData(data);
    setIsWarningModalVisible(true);
  };

  const blockedModal = (data) => {
    setData(data);
    setIsBlockedModalVisible(true);
  };

  const CustomButton = ({ onClick, label }) => (
    <button
      className="btn btn-primary btn_contained btn-sm fs_12"
      onClick={onClick}
    >
      {label}
    </button>
  );

  const onCloseStudentDetails = () => {
    setStudentDetail(undefined);
    setIsStudentDetailsVisible(false);
  };

  const viewCellRenderer = ({ value, data }) => (
    <CustomButton
      label={value === "View" ? "View" : "View"}
      onClick={async () => {
        setStudentDetail(data);
        setIsStudentDetailsVisible(true);
      }}
    />
  );

  const actionCellRenderer = ({ data }) => (
    <Popover content={popoverContent(data)} trigger="hover">
      <img
        src={actionBtn}
        alt="Warning / Blocked"
        style={{ width: "30px", height: "17px", cursor: "pointer" }}
      />
    </Popover>
  );

  const popoverContent = (data) => (
    <div className="text-center">
      {/* <Button
        className="btn btn-sm text-secondary fs_12 border-0"
        onClick={() => {
          warningModal(data);
          console.log("Warning data", data);
        }}
      >
        <div className="d-flex justify-content-between">
          <div className="mr-1">
            <ImWarning className={`text-secondary ${styles.cicon}`} />
          </div>
          <div>Warning</div>
        </div>
      </Button>
      <br /> */}
      <Button
        className="btn btn-sm text-danger fs_12 border-0"
        onClick={() => {
          blockedModal(data);
        }}
      >
        <div className="d-flex justify-content-between">
          <div className="mr-1">
            <ImBlocked className={`text-danger ${styles.cicon}`} />
          </div>
          <div>{data.isBlocked ? "Unblock" : "Block"}</div>
        </div>
      </Button>
    </div>
  );

  const ImageAndNameRenderer = ({ data }) => (
    <div className="d-flex align-items-center">
      <div>
        <span
          style={{
            marginLeft: "8px",
            display: "block",
          }}
        ></span>
      </div>
    </div>
  );

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true); // Set loading to true before starting fetch
      try {
        const response = await getStudents();
        if (response.status === 200) {
          // console.log("Student Data fetched successfully", response);
          setRowData(response?.data?.data);
        } else {
          // console.log("Error fetching data:", response.statusText);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false); // Set loading to false after fetch completes
      }
    };

    fetchData();
  }, []);

  const {
    data: allStudent,
    isLoading: isLoadingAllStudent,
    isError: isErrorAllStudent,
  } = useAllStudents();

  const getRowHeight = (params) => {
    var Heights = [55, 55, 55, 55];
    return Heights[params.node.rowIndex % 4];
  };

  const gridOptions = {
    getRowHeight: getRowHeight,
  };

  const centerStyle = {
    display: "flex",
    alignItems: "center",
    fontSize: "14px",
  };

  const columnDefs = [
    {
      headerName: "Student",
      field: "fullName",
      flex: 1,
      filter: true,
      cellStyle: centerStyle,
    },
    {
      headerName: "Address",
      field: "address",
      flex: 1,
      filter: true,
      cellStyle: centerStyle,
      valueGetter: (params) => params.data?.address || "N/A",
    },
    {
      headerName: "Profile",
      field: "view",
      flex: 1,
      cellRenderer: viewCellRenderer,
      cellStyle: centerStyle,
    },
    {
      headerName: "Blocked",
      field: "isBlocked",
      flex: 1,
      cellRenderer: (param) => (
        <Chip
          label={param?.data?.isBlocked ? "Blocked" : "Open"}
          color={param?.data?.isBlocked ? "error" : "success"}
          size="small"
          sx={{ mr: 0.5, mb: 0.5 }}
        />
      ),
      cellStyle: centerStyle,
    },
    {
      headerName: "Action",
      field: "action",
      flex: 1,
      cellRenderer: actionCellRenderer,
      cellStyle: centerStyle,
    },
  ];

  const handleBlockedModalCancel = () => {
    setData(undefined);
    setIsBlockedModalVisible(false);
  };

  const handleBlockedModalOk = async () => {
    try {
      const response = await toggleBlockStudent(
        data?.id,
        !data?.isBlocked,
        blockedMessage
      );
      if (response.status === 200) {
        toast.success(
          `Student ${!data?.isBlocked ? "blocked" : "unblocked"} successfully.`
        );
        // console.log("Student blocked/unblocked successfully", response);
        setRowData((prevRowData) => {
          return prevRowData.map((student) => {
            if (student.id === data.id) {
              return { ...student, isBlocked: !data?.isBlocked };
            }
            return student;
          });
        });
      } else {
        console.error(
          "Error blocking/unblocking student:",
          response.statusText
        );
        toast.error(
          `Failed to ${data?.isBlocked ? "unblock" : "block"} student.`
        );
      }
    } catch (error) {
      console.error("Error blocking/unblocking student:", error);
      toast.error("An error occurred. Please try again.");
    }
    handleBlockedModalCancel();
  };

  const renderModal = !!data;

  const filterTextBox = () => {
    // console.log("Clicked Filter");
  };

  const handleOnChange = (e) => {
    setInput(e.target.value);
    // console.log("Value Changed !", e.target.value);
  };

  const rowDataFiltered = Array.isArray(rowData)
    ? rowData.filter((item) => {
        if (!input) return true;
        return Object.keys(item).some((key) => {
          if (typeof item[key] === "string") {
            const s1 = (item[key] || "").toLowerCase();
            const s2 = (input || "").toLowerCase();
            return s1.includes(s2);
          }
          return false;
        });
      })
    : [];

  return (
    <div id="">
      <Layout>
        <div className="d-flex justify-content-between align-items-end px-3">
          <div>
            <h3 className="h3">Total Students</h3>
            <span className="fs_12">
              Total Number of Students
              <span className="fw-bold"> "{rowData.length}"</span>
            </span>
          </div>
          <div>
            <form className="d-flex rounded" role="search">
              <div
                className={`d-flex rounded ${styles.searchBG_color} my-1 shadow-sm`}
              >
                <input
                  type="search"
                  id="filterTextBox"
                  onClick={filterTextBox}
                  onChange={handleOnChange}
                  className={`form-control ${styles.fee_input} border-0 rounded form_control_focus_box_shadow_none ${styles.searchBG_color}`}
                  placeholder={"Search..."}
                  value={input}
                  aria-label="Username"
                  aria-describedby="basic-addon1"
                  style={{
                    color: "#000",
                    opacity: 1,
                    fontSize: "13px",
                    "::placeholder": {
                      color: "white",
                      fontSize: "12px",
                    },
                  }}
                />
                <AiOutlineSearch className={`${styles.searhIcon}`} />
              </div>
            </form>
          </div>
        </div>
        {/* Loading Indicator */}
        {loading ? (
          <div className="text-center">
            <div
              style={{
                display: "flex",
                paddingLeft: "30px",
                height: "200px",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              Loading
            </div>
          </div>
        ) : (
          <div className="d-flex flex-wrap justify-content-between">
            <div
              className={`fs_14 pt-1 col-md-${
                isStudentDetailsVisible ? "7" : "12"
              } col-sm-12`}
            >
              <AdminGrid
                row={rowDataFiltered}
                cols={columnDefs}
                rowClass={"fs_12"}
                gridOptions={gridOptions}
                style={{ height: "103%" }}
                pagination={true}
              />
            </div>

            {isStudentDetailsVisible && (
              <StudentDetails
                onCloseStudentDetails={onCloseStudentDetails}
                studentDetail={studentDetail}
              />
            )}
          </div>
        )}

        <ReviewsModal
          isModalVisible={isReviewsModalVisible}
          setIsModalVisible={setIsReviewsModalVisible}
        />

        <WarningModal
          isModalVisible={isWarningModalVisible}
          setIsModalVisible={setIsWarningModalVisible}
          data={data}
          role="student"
        />

        {renderModal && (
          <BlockedModal
            data={data}
            Message={blockedMessage}
            setMessage={setBlockedMessage}
            isBlockedModalVisible={isBlockedModalVisible}
            handleCancel={handleBlockedModalCancel}
            role="student"
            title="Block Student"
            handleOk={handleBlockedModalOk}
          />
        )}
      </Layout>
    </div>
  );
}

export default TotalStudent;
